import { render } from "./PubArticle.vue?vue&type=template&id=9b3a226a"
import script from "./PubArticle.vue?vue&type=script&lang=js"
export * from "./PubArticle.vue?vue&type=script&lang=js"

import "./PubArticle.vue?vue&type=style&index=0&id=9b3a226a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__